module.exports = __webpack_public_path__ + "static/img/note.34f935d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/note.png
// module id = z1Ad
// module chunks = 1